import { Text } from '@betterment/samba-react';

export const SummaryAnnualReport: React.FC = () => {
  return (
    <Text as="p">
      The SAR summarizes certain plan information reported by the Form 5500. It will contain any administrative expenses
      incurred by the plan, amount of benefits paid to participants and beneficiaries and total value of plan assets.
      All participants must receive a SAR within 9 months after the close of the plan year, or 2 months after the Form
      5500's filing deadline (if later).
    </Text>
  );
};
